// added to restrict user to only adding 1 specific product to their cart - 21/08/2026
(function () {
  const GATED_VARIANT_ID = 55270378602872;
  const BLOCKED_MESSAGE  = 'The Piccadilly Pilsner 24-pack offer cannot be combined with other products. Please remove other items to continue.';

  function checkCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const hasGatedVariant  = cart.items.some(i => i.variant_id === GATED_VARIANT_ID);
        const hasOtherProducts = cart.items.some(i => i.variant_id !== GATED_VARIANT_ID);
        const btn = document.getElementById('CheckOut');
        if (!btn) return;

        const existing = document.getElementById('cart-gate-msg');

        if (hasGatedVariant && hasOtherProducts) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          if (!existing) {
            const msg = document.createElement('p');
            msg.id = 'cart-gate-msg';
            msg.className = 'cart-gate-msg';
            msg.textContent = BLOCKED_MESSAGE;
            btn.insertAdjacentElement('afterend', msg);
          }
        } else {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
          if (existing) existing.remove();
        }
      });
  }

  function init() {
    checkCart();

    // Watch AjaxCartSubtotal — the theme replaces its innerHTML on every
    // cart update, which resets the button. Re-run our check after each swap.
    const subtotal = document.getElementById('AjaxCartSubtotal');
    if (subtotal) {
      new MutationObserver(checkCart).observe(subtotal, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();